"use client";

import { MapPin, Phone, Mail } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactDetails() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const contactItems = [{
    id: 1,
    icon: MapPin,
    label: "Address",
    value: "2259 Merion Ct, Brentwood, CA 94513"
  }, {
    id: 2,
    icon: Phone,
    label: "Phone",
    value: "925-232-1539"
  }, {
    id: 3,
    icon: Mail,
    label: "Email",
    value: "info@restoreandhopellc.com"
  }];
  return <section ref={ref} className={`py-16 px-6 md:px-12 lg:px-24 bg-background transition-all duration-300 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {}
          <div className="flex flex-col gap-6">
            {contactItems.map((item, i) => {
            const Icon = item.icon;
            return <div key={item.id} data-index={i} className="bg-muted rounded-lg p-6 shadow-soft transition-all duration-300 ease-out hover:translate-y-[-4px] hover:shadow-medium">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                      <Icon className="w-6 h-6 text-primary" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className={`text-lg font-semibold mb-1 ${i === 0 || i === 1 || i === 2 ? 'text-black' : 'text-foreground'}`}>
                        {item.label}
                      </h3>
                      <p className={`${i === 0 || i === 1 || i === 2 ? 'text-black' : 'text-foreground'} break-words`}>
                        {item.value}
                      </p>
                    </div>
                  </div>
                </div>;
          })}
          </div>

          {}
          <div className="h-full min-h-[400px] lg:min-h-full rounded-lg overflow-hidden shadow-soft">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1477031/img/contact_map_location.png" alt="Location Map" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>
    </section>;
}